/* eslint-disable camelcase */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TeamLineupsContext } from 'widgets/mc-team-lineups/js/components/MCTeamLineups';
import { TAPlayerList } from './TAPlayerList';

/**
 * Renders the ins and outs data.
 *
 * @param {object} props - The props
 * @param {Array} props.playersIn - The players in data.
 * @param {Array} props.playersOut - The players out data.
 * @param {boolean} props.isAFLW - Competition is AFLW check.
 * @param {string} props.clubId - The player's club/team ID.
 * @returns {React.JSX.Element} - The formatted substitutes data.
 */
export const TeamAnnouncementsInsOuts = ({
    playersIn,
    playersOut,
    isAFLW,
    clubId
}) => {
    const teamLineupsContext = useContext(TeamLineupsContext);

    return (
        <p className="team-announcements__substitutes">
            <span className="team-announcements__substitutes-team">
                <span className="team-announcements__substitutes-title team-announcements__substitutes-title--in content-tag">
                    {PULSE.I18N.lookup('label.teamlineups.playerIn')}
                </span>

                <span className="team-announcements__substitutes-values">
                    <TAPlayerList
                        players={playersIn}
                        prefix="subIn"
                        isAFLW={isAFLW}
                        clubId={clubId}
                        context={teamLineupsContext}
                    />
                </span>
            </span>

            <span className="team-announcements__substitutes-team">
                <span className="team-announcements__substitutes-title team-announcements__substitutes-title--out content-tag">
                    {PULSE.I18N.lookup('label.teamlineups.playerOut')}
                </span>

                <span className="team-announcements__substitutes-values">
                    <TAPlayerList
                        players={playersOut}
                        prefix="subOut"
                        isAFLW={isAFLW}
                        clubId={clubId}
                        context={teamLineupsContext}
                    />
                </span>
            </span>
        </p>
    );
};

TeamAnnouncementsInsOuts.propTypes = {
    playersIn: PropTypes.array,
    playersOut: PropTypes.array,
    isAFLW: PropTypes.bool,
    clubId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
